/* DEKOFAR V2 SMART PRODUCT RECOMMENDATIONS */
(function () {
  'use strict';

  function parseSection(htmlText) {
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    return doc.querySelector('[data-dekofar-v2-rec-response]');
  }

  async function fetchSection(url) {
    if (!url) return null;
    try {
      var response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return null;
      return parseSection(await response.text());
    } catch (e) {
      return null;
    }
  }

  async function initElement(element) {
    if (!element || element.dataset.dekofarV2RecommendationsInitialized === 'true') return;
    element.dataset.dekofarV2RecommendationsInitialized = 'true';

    var fallback = element.innerHTML;
    element.classList.add('is-loading');

    var section = await fetchSection(element.dataset.complementaryUrl);
    if (!section) section = await fetchSection(element.dataset.relatedUrl);

    if (section) {
      element.innerHTML = section.outerHTML;
      element.dataset.dekofarV2RecommendationsLoaded = 'true';
    } else if (!fallback.trim()) {
      element.remove();
      return;
    } else {
      element.innerHTML = fallback;
      element.dataset.dekofarV2RecommendationsLoaded = 'fallback';
    }

    element.classList.remove('is-loading');
    element.dispatchEvent(new CustomEvent('dekofar:v2:recommendations-loaded', { bubbles: true }));
  }

  var observer = null;

  function queueElement(element) {
    if (!element || element.dataset.dekofarV2RecommendationsQueued === 'true') return;
    element.dataset.dekofarV2RecommendationsQueued = 'true';

    if (!('IntersectionObserver' in window)) {
      initElement(element);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initElement(entry.target);
        });
      }, { rootMargin: '700px 0px' });
    }

    observer.observe(element);
  }

  function init(scope) {
    var root = scope || document;
    if (root.matches && root.matches('[data-dekofar-v2-product-recommendations]')) queueElement(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-dekofar-v2-product-recommendations]').forEach(queueElement);
  }

  window.dekofarV2InitProductRecommendations = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
})();
